export enum VerificationState {
  REQUEST,
  CONFIRM,
}

export enum PhoneVerificationStatus {
  CANCELLED,
  SUCCESS,
}

export enum PhoneVerificationToastAlertItem {
  INVALID_CODE = 'verification-code-invalid',
  INVALID_VERIFICATION = 'verification-invalid',
  GENERIC_ERROR = 'verification-error',
}
